/* eslint-disable camelcase */
// Send new question action
export const SEND_QUESTION_REQUEST = 'routes/HomeworkHelp/sendQuestionRequest';
export const SEND_QUESTION_SUCCESS = 'routes/HomeworkHelp/sendQuestionSuccess';
export const SEND_QUESTION_FAILURE = 'routes/HomeworkHelp/sendQuestionFailure';

// Fetch chats actions
export const FETCH_CHATS_REQUEST = 'routes/HomeworkHelp/fetchChatsRequest';
export const FETCH_CHATS_SUCCESS = 'routes/HomeworkHelp/fetchChatsSuccess';
export const FETCH_CHATS_FAILURE = 'routes/HomeworkHelp/fetchChatsFailure';

// Fetch conversations actions
export const FETCH_CONVERSATIONS_REQUEST = 'routes/HomeworkHelp/fetchConversationsRequest';
export const FETCH_CONVERSATIONS_SUCCESS = 'routes/HomeworkHelp/fetchConversationsSuccess';
export const FETCH_CONVERSATIONS_FAILURE = 'routes/HomeworkHelp/fetchConversationsFailure';

// Send new conversation question action
export const SEND_CONVERSATION_QUESTION_REQUEST = 'routes/HomeworkHelp/sendConversationQuestionRequest';
export const SEND_CONVERSATION_QUESTION_SUCCESS = 'routes/HomeworkHelp/sendConversationQuestionSuccess';
export const SEND_CONVERSATION_QUESTION_FAILURE = 'routes/HomeworkHelp/sendConversationQuestionFailure';

// update user odh policies
export const UPDATE_USER_ODH_POLICIES = 'routes/HomeworkHelp/updateUserODHPolicies';

// Action creators for chats
export const sendQuestionRequest = (request, intl) => ({
    type: SEND_QUESTION_REQUEST,
    payload: { request, intl },
});

export const createChatSuccess = (chat) => ({
    type: SEND_QUESTION_SUCCESS,
    payload: chat,
});

export const createChatFailure = (error) => ({
    type: SEND_QUESTION_FAILURE,
    payload: error,
});

// Action fetch for chats
export const fetchChatsRequest = (page, pageSize, userId, intl, clear) => ({
    type: FETCH_CHATS_REQUEST,
    payload: { page, pageSize, userId, intl, clear },
});

export const fetchChatsSuccess = (chats) => ({
    type: FETCH_CHATS_SUCCESS,
    payload: chats,
});

export const fetchChatsFailure = (error) => ({
    type: FETCH_CHATS_FAILURE,
    payload: error,
});

// Action creators for conversation
export const sendConversationQuestion = (request, intl) => ({
    type: SEND_CONVERSATION_QUESTION_REQUEST,
    payload: { request, intl },
});

export const createConversationQuestionSuccess = (chatId, conversation) => ({
    type: SEND_CONVERSATION_QUESTION_SUCCESS,
    payload: { chatId, conversation },
});

export const createConversationQuestionFailure = (error) => ({
    type: SEND_CONVERSATION_QUESTION_FAILURE,
    payload: error,
});

// Action fetch for conversations
export const fetchConversationsRequest = (id, intl) => ({
    type: FETCH_CONVERSATIONS_REQUEST,
    payload: { id, intl },
});

export const fetchConversationsSuccess = (id, conversations) => ({
    type: FETCH_CONVERSATIONS_SUCCESS,
    payload: { id, conversations },
});

export const fetchConversationsFailure = (id, error) => ({
    type: FETCH_CONVERSATIONS_FAILURE,
    payload: { id, error },
});

export const updateODHPolicies = (userId, hasODHPoliciesAccepted, intl) => ({
    type: UPDATE_USER_ODH_POLICIES,
    payload: {
        userId,
        hasODHPoliciesAccepted,
    },
    intl,
});
